var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var isAdvertisingTrackObject = function (track) {
    return "client_id" in track && track.client_id !== null;
};
var mapBaseTrackObject = function (_a) {
    var id = _a.id, title = _a.title, duration = _a.duration, formatted_duration = _a.formatted_duration, created_at = _a.created_at, updated_at = _a.updated_at, url = _a.url, ISRC = _a.ISRC;
    return {
        id: id,
        title: title,
        duration: {
            seconds: duration,
            formatted: formatted_duration,
        },
        createdAt: created_at,
        updatedAt: updated_at,
        url: url,
        ISRC: ISRC,
    };
};
export var mapCatalogTrackObject = function (track) {
    return __assign(__assign({}, mapBaseTrackObject(track)), { type: "public", artist: track.artist, genres: track.genres, isNormalized: track.is_normalized, isApproved: track.is_approved, ISRC: track.ISRC });
};
export var mapRawTrackObject = function (track) {
    return __assign(__assign({}, mapBaseTrackObject(track)), { artist: track.artist, genres: track.genres, size: track.size, md5: track.md5, formatted_duration: track.formatted_duration, created_at: created_at, updated_at: updated_at, user_id: track.user_id, client_id: track.client_id, is_private: track.is_private, is_approved: track.is_approved, duration: track.duration, ISRC: track.ISRC, is_normalized: track.is_normalized });
};
export var mapAdvertisementTrackObject = function (track) { return (__assign(__assign({}, mapBaseTrackObject(track)), { type: "private" })); };
export var mapTrackObject = function (track) {
    if (isAdvertisingTrackObject(track)) {
        return mapAdvertisementTrackObject(track);
    }
    return mapCatalogTrackObject(track);
};
